import { connect } from 'react-redux';

import { makeEstimationMessage } from 'modules/conference/selectors/etimatedTimeMessageFormattor';
import { getAppointmentsEstimatedTimeToBeServedSelector } from 'modules/queues/Schedule/selectors/appointments';

import AppointmentSchedule from './AppointmentSchedule';

const mapStateToProps = (state, ownProps) => ({
  expectedTime: makeEstimationMessage(getAppointmentsEstimatedTimeToBeServedSelector(state)[ownProps.appointmentId]),
});

export default connect(mapStateToProps)(AppointmentSchedule);
